module.exports = __webpack_public_path__ + "img/ebay-card.917b7334.svg";